import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

export const SplitPageWrapper = styled.div`
	${media.lessThan(breakpoints.ipad)`
	flex-direction: column;
	padding: ${({ smallpadding }) => (smallpadding ? smallpadding : "0 1rem")}
  `};
	${media.greaterThan(breakpoints.ipad)`
	padding: ${({ Padding }) => Padding};
  `};

	& {
		max-width: ${({ maxWidth, theme }) => (maxWidth ? maxWidth : theme.grid.outer)};
		margin: 0 auto;
		display: flex;
		justify-content: ${({ centerContent }) => (centerContent ? "center" : "space-between")};
	}
`;
